import { Question } from './../../models/QuestionCreateData';
export enum EvaluationQuestionTypes {
    GET_QUESTION_REQUEST = '@evaluationQuestion/GET_QUESTION_REQUEST',
    GET_QUESTION_SUCCESS = '@evaluationQuestion/GET_QUESTION_SUCCESS',
    GET_QUESTION_FAILURE = '@evaluationQuestion/GET_QUESTION_FAILURE',
    GET_QUESTION_CLEAR = '@evaluationQuestion/GET_QUESTION_CLEAR',

    GET_QUESTIONS_REQUEST = '@evaluationQuestion/GET_QUESTIONS_REQUEST',
    GET_QUESTIONS_SUCCESS = '@evaluationQuestion/GET_QUESTIONS_SUCCESS',
    GET_QUESTIONS_FAILURE = '@evaluationQuestion/GET_QUESTIONS_FAILURE',

    POST_QUESTION_CLEAR = '@evaluationQuestion/POST_QUESTION_CLEAR',
    POST_QUESTION_REQUEST = '@evaluationQuestion/POST_QUESTION_REQUEST',
    POST_QUESTION_SUCCESS = '@evaluationQuestion/POST_QUESTION_SUCCESS',
    POST_QUESTION_FAILURE = '@evaluationQuestion/POST_QUESTION_FAILURE',

    PUT_QUESTION_REORDER_REQUEST = '@evaluationQuestion/PUT_QUESTION_REORDER_REQUEST',
    PUT_QUESTION_REORDER_SUCCESS = '@evaluationQuestion/PUT_QUESTION_REORDER_SUCCESS',
    PUT_QUESTION_REORDER_FAILURE = '@evaluationQuestion/PUT_QUESTION_REORDER_FAILURE',

    POST_QUESTION_RENEW_CLEAR = '@evaluationQuestion/POST_QUESTION_RENEW_CLEAR',
    POST_QUESTION_RENEW_REQUEST = '@evaluationQuestion/POST_QUESTION_RENEW_REQUEST',
    POST_QUESTION_RENEW_SUCCESS = '@evaluationQuestion/POST_QUESTION_RENEW_SUCCESS',

    PUT_QUESTION_CLEAR = '@evaluationQuestion/PUT_QUESTION_CLEAR',
    PUT_QUESTION_REQUEST = '@evaluationQuestion/PUT_QUESTION_REQUEST',
    PUT_QUESTION_SUCCESS = '@evaluationQuestion/PUT_QUESTION_SUCCESS',
    PUT_QUESTION_FAILURE = '@evaluationQuestion/PUT_QUESTION_FAILURE',

    DELETE_QUESTION_REQUEST = '@evaluationQuestion/DELETE_QUESTION_REQUEST',
    DELETE_QUESTION_SUCCESS = '@evaluationQuestion/DELETE_QUESTION_SUCCESS',
    DELETE_QUESTION_FAILURE = '@evaluationQuestion/DELETE_QUESTION_FAILURE',
}
export interface Questions {
    questions: Question[];
}
export interface EvaluationQuestionState {
    list: Questions;
    data: any;
    isNew: boolean;
    loading: boolean;
    success: boolean;
    hasError: boolean;
    successOnDelete: boolean;
}
